import { render, staticRenderFns } from "./widget-editor-reapply-template.vue?vue&type=template&id=36416989&scoped=true&"
import script from "./widget-editor-reapply-template.vue?vue&type=script&lang=js&"
export * from "./widget-editor-reapply-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36416989",
  null
  
)

export default component.exports